import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import styled from '@emotion/styled';
import Row from '../../../components/Measure/Row';
import { useAuthDataContext } from '../../../components/AuthProvider';
import { useNavigate } from 'react-router-dom';
//////////////////////////////////
const RootStyle = styled('div')({
  height: '100vh',
  display: 'grid',
});

const ContentStyle = styled('div')({
  maxWidth: 480,
  padding: 25,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  background: '#fff',
});

const Auth = ({ isLogin }) => {
  const navigate = useNavigate();
  const { authData, isdemo } = useAuthDataContext();
  useEffect(() => {
    if (isdemo || !authData.email) {
      navigate('/');
    }
  }, [authData, isdemo]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <RootStyle>
      <Container maxWidth="sm">
        <ContentStyle>
          <Row />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
};

export default Auth;
